const DEGREES = [
  { key: 'BACHELOR', name: 'Bachelor' },
  { key: 'MASTER', name: 'Master' },
  { key: 'DIPLOMA', name: 'Diplom' }
];

export default DEGREES;
